import {
  combineStores,
  useLocalStorageStore,
  usePersistedState,
  useURLSearchParamsStore,
} from '../../../hooks/use-persisted-state';

export const useURLAndLocalPersistentState = <S>(key: string, initialState: S) => {
  const urlStore = useURLSearchParamsStore();
  const localStore = useLocalStorageStore();
  return usePersistedState(key, initialState, combineStores([urlStore, localStore]));
};
